// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond20Circle: FC<Diamond20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m16.072 13.406-4.062 4.082-4.063-4.082h8.125ZM14.2 9.656 16.172 12H7.828L9.82 9.656H14.2Z" />
            <path
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0ZM9.143 8.25l-3.825 4.512L12.01 19.5l6.691-6.738-3.823-4.512H9.143ZM5 6.59l1.692 1.66 1.016-.996-1.692-1.66L5 6.59Zm11.292.664 1.016.996L19 6.59l-1.016-.996-1.692 1.66ZM11.293 4.5v2.344h1.434V4.5h-1.434Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Diamond20Circle;
